<template>
  <div class="hailingLicenceInfo">
    <QS-h4-title title="网约车驾驶员证" />
    <QS-column-box
      :source="source"
      :list="list"
      :column="3"
      labelWidth="200"
      separator=":"
    >
      <template slot="hailingLicenceUrl">
        <EnlargeImg :imgSrc="source.hailingLicenceUrl ||''" class="avatar" />
      </template>
      <template slot="hailingLicenceValidDate">
        {{ longDate }}
      </template>
    </QS-column-box>
  </div>
</template>
<script>
import { longDateFormat } from '@/utils'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    longDate() {
      return longDateFormat('hailingLicenceValidDate', this.source)
    },
  },
}
</script>

<style lang="scss" scoped>
.hailingLicenceInfo{
  img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
